import { useEffect, useRef, useState } from 'react';

const SCROLL_TOLERANCE = 2;

const useLpCommitmentsModal = ({ isOpen, onClose }) => {
    const contentRef = useRef(null);
    const [contentScrollState, setContentScrollState] = useState({
        hasMoreAbove: false,
        hasMoreBelow: false,
    });

    useEffect(() => {
        if (!isOpen) return undefined;

        const prevBodyOverflow = document.body.style.overflow;
        const prevHtmlOverflow = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        const handleEscape = (event) => {
            if (event.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = prevBodyOverflow;
            document.documentElement.style.overflow = prevHtmlOverflow;
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        if (!isOpen) return undefined;

        const el = contentRef.current;
        if (!el) return undefined;

        const update = () => {
            const maxScroll = Math.max(el.scrollHeight - el.clientHeight, 0);
            setContentScrollState({
                hasMoreAbove: el.scrollTop > SCROLL_TOLERANCE,
                hasMoreBelow: el.scrollTop < maxScroll - SCROLL_TOLERANCE,
            });
        };

        update();
        el.addEventListener('scroll', update);
        window.addEventListener('resize', update);

        return () => {
            el.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
        };
    }, [isOpen]);

    return { contentRef, contentScrollState };
};

export default useLpCommitmentsModal;
